import * as React from 'react';
import { useCCCAddressFormSlots } from '../../../slots/CCCAddressFormSlotsContext.js';

const DeliveryAddressesSummary = ({ handleEditClick , subscription ,  })=>{
    const { deliveryAddress  } = subscription;
    const { Slots: { summary: SummaryTemplate  } ,  } = useCCCAddressFormSlots();
    if (!SummaryTemplate) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(SummaryTemplate, {
        addressType: "deliveryAddress",
        actions: {
            onEdit: handleEditClick
        },
        className: "ccc-deliveries__addresses-summary-slot",
        values: deliveryAddress
    });
};
var DeliveryAddressesSummary$1 = DeliveryAddressesSummary;

export { DeliveryAddressesSummary$1 as default };
//# sourceMappingURL=DeliveryAddressesSummary.js.map
